"use client";

import React from 'react';


export default function DashboardPreviewSection() {
  return (
    <section className="relative py-24 bg-deep-dark overflow-hidden">
      {/* Background gradient */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-30"
        style={{
          background: "radial-gradient(ellipse 80% 60% at 50% 40%, rgba(91, 46, 255, 0.2) 0%, transparent 70%)"
        }}
      />
      <div className="container mx-auto px-6 relative z-10">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-text-primary mb-4">
            Real-Time Dashboard
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Track inventory, orders, and shipments in real-time. No more chasing updates via email.
          </p>
        </div>

        {/* Dashboard mockup */}
        <div className="max-w-6xl mx-auto">
          <div 
            className="relative rounded-3xl overflow-hidden"
            style={{
              background: "linear-gradient(145deg, rgba(91, 46, 255, 0.1) 0%, rgba(124, 77, 255, 0.05) 100%)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.5), 0 0 40px rgba(91, 46, 255, 0.2)"
            }}
          >
            {/* Dashboard header */}
            <div className="bg-secondary-dark/80 backdrop-blur-xl border-b border-divider p-6">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-xl font-bold text-text-primary mb-1">Fulfilment Dashboard</h3>
                  <p className="text-sm text-text-secondary">Real-time inventory & order tracking</p>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full bg-accent-primary animate-glow-pulse" />
                  <span className="text-sm font-medium text-text-secondary">Live</span>
                </div>
              </div>
            </div>

            {/* Dashboard content */}
            <div className="p-8 space-y-6">
              {/* Metrics row */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {[
                  { label: "Orders Today", value: "247", change: "+12%" },
                  { label: "In Transit", value: "1,834", change: "+8%" },
                  { label: "Inventory", value: "12.4K", change: "-3%" },
                  { label: "Avg. Ship Time", value: "5.2d", change: "-0.3d" }
                ]?.map((metric, index) => (
                  <div 
                    key={index}
                    className="glass-card p-4"
                  >
                    <div className="text-sm text-text-secondary mb-2">{metric?.label}</div>
                    <div className="text-2xl font-bold text-text-primary mb-1">{metric?.value}</div>
                    <div className="text-xs font-semibold text-accent-primary">{metric?.change}</div>
                  </div>
                ))}
              </div>

              {/* Chart placeholder */}
              <div className="glass-card p-6">
                <div className="flex items-center justify-between mb-4">
                  <h4 className="font-semibold text-text-primary">Order Volume</h4>
                  <div className="flex gap-2">
                    <span className="text-xs px-3 py-1 rounded-full bg-accent-primary/10 text-accent-primary font-medium">7 days</span>
                  </div>
                </div>
                {/* Simple bar chart visualization */}
                <div className="flex items-end justify-between gap-2 h-32">
                  {[65, 78, 82, 90, 75, 88, 95]?.map((height, index) => (
                    <div key={index} className="flex-1 flex flex-col items-center gap-2">
                      <div 
                        className="w-full rounded-t-lg transition-all"
                        style={{
                          height: `${height}%`,
                          background: "linear-gradient(180deg, #5B2EFF 0%, #7C4DFF 100%)",
                          boxShadow: "0 0 20px rgba(91, 46, 255, 0.4)"
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}